import { useUser } from '@/domain/user/hooks'
import styles from './UserAvatar.module.css'

export default function UserAvatar() {
  const { capitalLetter } = useUser()

  return <div className={styles.avatar}>{capitalLetter}</div>
}
